import { Box, Typography } from "@mui/material";

export const Badge = ({ label }: { label: string }) => {
  return (
    <Box
      sx={{
        px: 0.75,
        py: 0.5,
        borderRadius: "2px",
        backgroundColor: "grey.100",
      }}
    >
      <Typography fontSize="12px">{label}</Typography>
    </Box>
  );
};
